import React from 'react';
import { Link } from "react-router-dom";


import '../../global.css';
import '../huntedit/GameDetail.css'
import {BOUNDS, CLUES, PREMIUM, PUBLIC, PUBLISHED, TITLE} from "../../constants/Game";


export const Title = props => {

    const {game, className} = props;
    const title = game[TITLE];
    return (
       <div className={className}>
           <h2 align="center" className="GameDetail-top-padding bottom-margin user">
               {title}
           </h2>
       </div>);
};

export const Header = props => {

    const { game } = props;

    const isPublished = game[PUBLISHED];
    const isPublic = game[PUBLIC];

    const publicPrivateStatus = isPublic ? isPublished ? "Public" : "Public when published" : "Private";

    return (
        <div>
            <div>
                <div className="pull-right secondary-text right-margin">
                    {publicPrivateStatus}
                </div>

                <Link className="accent-link no-side-margins" to="/games">
                    Back To Home
                </Link>
            </div>
        </div>
    )
};

export const HuntStatus = props => {

    const { editable, isSample, game, className } = props;
    const { onUnpublishClick, onPublishClick, onDeleteClick}  = props;

    const isPublished = game[PUBLISHED];

    const hasBounds = (game[BOUNDS]);
    const hasClues =  game[CLUES] && game[CLUES].length > 0;
    const isPublishable = determineIsPublishable(isPublished, hasClues, hasBounds);

    return (
       <div className={className}>

           <PublishRequirements game={game} sampleOnly={!editable && isSample}/>

           {(editable && !isPublished) ?
              <div>
                  <button
                     className="btn btn-link pull-right small-top-margin"
                     onClick={onDeleteClick}>
                                <span className="text-danger">
                                    Delete Hunt
                                </span>
                  </button>
              </div>
              : " "}

           {editable ?
              <PublishButton
                 isPublishable={isPublishable}
                 isPublished={isPublished}
                 onUnpublishClick={onUnpublishClick}
                 onPublishClick={onPublishClick}/>
              : ""}
       </div>
    )
};

export const PrivatePublicBlock = props => {

    const { game, className, editable } = props;
    const { fetchCodeClicked, onConvertClicked }  = props;
    const { genQuickLinkClicked }  = props;
    const isPublic = game[PUBLIC];
    const isPublished = game[PUBLISHED];
    const accessCode = game['shortId'];
    const quickLink = game['deepLink'];
    const theme = game['theme'];
    const isPremium = game[PREMIUM]

    const title = isPublic ? "Public" : "Private";

    const convertText = isPublic ? "(Convert to private)" : "(Convert to public)";

    return (
       <div className={className}>

          <div>
              <h3 className="inline big-top-margin secondary-highlight">
                  {title}
                 {editable ?
                    <button className="btn btn-link edit-button accent-link" onClick={onConvertClicked}>
                       {convertText}
                    </button>
                    : ""}
              </h3>
              <p className="explanation secondary-text right-margin-only">
                  {getPublicPrivateText(isPublished, isPublic)}
              </p>
          </div>
           {!isPublic
              ? <PrivateAccessCode
                 code={accessCode}
                 buttonOnClick={fetchCodeClicked}/>
              : ""
           }
          {/*{!isPublic || isPremium*/}
          {/*   ? <QuickLinkBlock*/}
          {/*      quickLink={quickLink}*/}
          {/*      isPublic={isPublic}*/}
          {/*      buttonOnClick={genQuickLinkClicked}/>*/}
          {/*   : ""*/}
          {/*}*/}
          {/*<AboutThemeBlock theme={theme}/>*/}
       </div>
    )
};

// Returns empty <div> if the game is published.
// Otherwise, returns a blurb if the game it not published, but publishable.
// And a different blurb if it's not publishable, exlaining what it needs.
const PublishRequirements = props => {

    const { game, sampleOnly } = props;

    if (sampleOnly) {
       return ( <div><h4 className="text-primary"> <b>Sample</b> </h4>
          <span className="secondary-text"> This is for sample purposes so nothing here is changeable. </span>
       </div> )
    }

    if (game.isPublished) {
        return ( <div><h4 className="text-primary"> <b>Published</b> </h4>
            <span className="secondary-text"> Unpublish if something's not right or it needs more work. </span>
        </div> )
    }

    const clues = game.clues;
    const hasClues = clues && clues.length > 0;
    const hasBounds = game.bounding_box;

    const isPublishable = determineIsPublishable(game.isPublished, hasClues, hasBounds);

    if (isPublishable) {
        return ( <div className="top-margin">
                <h4 className="red-text"> <b> Not Published</b> </h4>
                <span className="secondary-text"> Hunt is publishable but currently unavailable to users.  Publish it when you're ready. </span>
            </div>
        );
    }

    return ( <div className="top-margin">
        <h4 className="font-weight-bold red-text"> <b>Not Publishable</b> </h4>
        <span className="secondary-text"> The following are required: </span>
        <ul>
            {hasClues ? "" : <li className="secondary-text">One of more clues.  See below.</li>}
            {hasBounds ? "" : <li className="secondary-text">Game bounds.  Use the map widget to set.</li>}
        </ul>
    </div> );
};

export const PrivateAccessCode = props => {

    const { code, buttonOnClick } = props;

    const jsx = code
       ? <b className="small-left-margin"> {code} </b>
        : <button
            className="btn btn-info"
            onClick={buttonOnClick}>
            Retrieve Code
        </button>;

    return (
        <div>
            <div className="top-margin text-info">   Access code:  {jsx} </div>
            <p className="right-margin-only top-padding-half secondary-text">
                Share this short code with your users so they can add this hunt from the main hunt list on the mobile app.</p>
        </div>
    );
};

export const AboutThemeBlock = props => {
   /*
   Always show this block
    */
   const { theme } = props;

   if (!!theme) {
      return (
       <div>
         <p className="right-margin-only top-padding-half secondary-text">
            <b>Theming</b> - This is a themed hunt!
          More theme info will be shown here coming soon. Contact <a className="accent-link no-side-margins" href="mailto:contact@ourtreasurehunt.com">contact@ourtreasurehunt.com</a> to change the theme.</p>
       </div>

      )
   } else {
      return (
         <div>
            <p className="right-margin-only top-padding-half secondary-text">
               <b>Theming</b> - This is <b>not</b> a branded, themed hunt. <br/>
               Learn more about <a className="accent-link no-side-margins" href={'https://www.ourtreasurehunt.com/branding'}>this upcoming, premium feature</a>.
            </p>
         </div>
      );
   }
}

export const QuickLinkBlock = props => {

   const { quickLink, isPublic, buttonOnClick } = props;

   // const explanationStart = isPublic
   //    ? "As a premium public hunt,"
   //    : "Instead of an access code,"

   const jsx = quickLink
     ? <div>
         Quick link: <b className="small-left-margin"> {quickLink} </b>
         <p className="right-margin-only top-padding-half red">
            <b> NOTE: Quick links, aka "dynamic" or "deep" links will no longer be supported by Google and will stop working on August 25, this year. </b>
         </p>
      </div>
      :
      <div>
         <p className="right-margin-only top-padding-half">
            (Quicklinks: We stopped allowing the creation of deep links in mid-July.  This only means users playing your hunt will need to download Our Treasure Hunt on their own from the Play Store or App Store.  They can find the hunt in the hunt list sorted by location, if it's public, or
            using the access code above if private.)
         </p>

      </div>
      // <button
      //    className="btn btn-info"
      //    onClick={buttonOnClick}>
      //    Generate quick link
      // </button>;

   return (
      <div>
         <div className="top-margin text-info">   {jsx} </div>
         {/*<p className="right-margin-only top-padding-half secondary-text">*/}
         {/*   {explanationStart} you can send a "quick link" to your users.  It will install and open Our Treasure Hunt <i>directly</i> to your hunt.*/}
         {/*   Users will be asked to enter a name and e-mail for purposes of your hunt's leaderboard.*/}
         {/*</p>*/}

         {/*Send this link to your users.  It will install and open Our Treasure Hunt directly to your hunt!  Without*/}
         {/*requiring account sign-up! </p>*/}

         {/*<p className="right-margin-only top-padding-half secondary-text">*/}
         {/*   Send this link to your users.  On an iPhone or Android device it will launch Our Treasure Hunt directly */}
         {/*   to your hunt!  (Also downloading the app if necessary.) </p>*/}
      </div>
   );
}

/** Returns empty <div> if isPublishable == false */
export const PublishButton = props => {

    const { isPublishable, isPublished, onUnpublishClick, onPublishClick } = props;

    if (!isPublishable) return ( <div> </div> );

    if (isPublished) {
        return (
            <div className="small-top-margin">
                <button className="btn btn-outline-warning accent-link" onClick={onUnpublishClick}>
                    Unpublish
                </button>
            </div>
        )
    }
    return (
        <div>
            <button className="btn btn-outline-primary accent-link small-top-margin" onClick={onPublishClick}>
                Publish
            </button>
        </div>
    )
};

export function getClueTypesString(clues) {
    if (!clues) {
        return "None";
    }

    let hasDuration = false;
    let hasCoded = false;
    let i;
    for (i=0; i < clues.length; i++) {
        const clue = clues[i];
        if (clue.duration_sec || clue.duration_min) {
            hasDuration = true;
        }
        if (clue.code) {
            hasCoded = true;
        }
    }
    if (hasDuration && hasCoded) {
        return "Both time released and answer codes"
    }
    else if (hasDuration) {
        return "All time released";
    }
    else if (hasCoded) {
        return "All answer codes";
    }
    return "None";
}

export function determineIsPublishable(published, hasClues, hasBounds) {
    return published || (hasClues && hasBounds);
}

export function getPublicPrivateText(isPublished, isPublic) {
    if (isPublic) {
        if (isPublished) return "This game is public and available to everyone.";
        else return "This game will be public and, when published, available to everyone.";
    } else {
        if (isPublished) return "This game is private and available only to those with the link.";
        else return "This game will be private and, when published, available to only those with the link.";
    //    or quick link.
    }
}

export function getPublishStateExplanationText(published, hasClues, hasBounds, isPublic) {
    const publishText = isPublic ? "to publish hunt." : "to make hunt available.";
    if (published) {
        if (isPublic) {
            return "This hunt is published and available.  Unpublish if something isn't right or it needs more work."
        } else {
            return "This hunt is currently available to those you've invited with this hunt's code.  Unpublish if something isn't right or it needs more work."
        }
    }
    else {
        const unavailable =  "Game currently unavailable to users.\n";
        return hasBounds
            ? hasClues > 0
                ? unavailable + "Game is publishable.  Publish it when you're ready."
                : unavailable + "One of more clues required " + publishText
            : hasClues
                ? unavailable + "Treasure hunt bounds required "  + publishText
                : unavailable + "Hunt bounds and clues required "  + publishText;
    }
}



// WEBPACK FOOTER //
// ./src/components/huntedit/GameDetailComponents.js